<template>
  <div class="record">
    <div class="searchBox">
      <a-row :gutter="24">
        <a-col
          span="12"
          style="display: flex;"
        >
          <!-- 名称 -->
          <div class="tag">
            {{ $t('admin-message-message/name') }}
          </div>
          <a-input
            v-model="form.title"
            :placeholder="$t('admin-record-record/name/number')"
          />
        </a-col>
        <a-col
          span="12"
          style="display: flex;"
        >
          <!-- 时间 -->
          <div class="tag" style="width: 90px">
            {{ $t("admin-profile-log/time") }}
          </div>
          <a-range-picker @change="timeChange" />
          <!-- 搜索按钮 -->
          <a-button
            type="primary"
            style="margin-left: 10%;width: 80px;"
            @click="getList"
          >
            {{ $t("user-productInfo-myProduct/search") }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <a-table
      :row-key="row=>row.id"
      :columns="columns"
      :data-source="data"
      class="table"
      :pagination="pagination"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="pageChange"
    >
      <!-- 操作人 -->
      <span
        slot="user"
        slot-scope="text"
      >
        {{ text.lastname }} {{ text.firstname }}
      </span>
      <!-- 修改内容 -->
      <span
        slot="content_cn"
        slot-scope="text"
      >
        <div
          class="content"
          @click="showDetail(text)"
        >{{ text }}</div>
      </span>
    </a-table>
    <!-- 修改内容模态框 -->
    <Modal
      :show-modal="showModal"
      :show-confirm="false"
      cancel-text="关闭"
      @cancel="cancel"
    >
      <div style="max-height: 50vh;overflow: auto;">{{ content }}</div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/views/components/Modal.vue'
import { logs } from '@/api/user'
import { getLKey } from '@/utils/auth'

const columns = [
  {
    title: '参赛编号',
    dataIndex: 'code'
  },
  {
    title: '作品名称',
    dataIndex: 'title'
  },
  {
    title: '时间',
    dataIndex: 'created_at'
  },
  {
    title: '操作人',
    dataIndex: 'user',
    scopedSlots: { customRender: 'user' }
  },
  {
    title: '修改内容',
    dataIndex: 'content_cn',
    scopedSlots: { customRender: 'content_cn' }
  }
]

export default {
  components: {
    Modal
  },
  data() {
    return {
      data: [],
      columns,
      form: {
        title: '',
        start_date: '',
        end_date: ''
      },
      pagination: {
        current: 1,
        total: 0
      },
      showModal: false,
      content: ''
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(e) {
      this.columns[0].title = this.$t('user-tools/code')
      this.columns[1].title = this.$t('user-productInfo-myProduct/name')
      this.columns[2].title = this.$t('admin-profile-log/time')
      this.columns[3].title = this.$t('admin-record-record/operator')
      this.columns[4].title = this.$t('admin-profile-log/content')
      this.columns[4].dataIndex = e === 'en' ? 'content_en' : 'content_cn'
    }
  },
  created() {
    this.columns[0].title = this.$t('user-tools/code')
    this.columns[1].title = this.$t('user-productInfo-myProduct/name')
    this.columns[2].title = this.$t('admin-profile-log/time')
    this.columns[3].title = this.$t('admin-record-record/operator')
    this.columns[4].title = this.$t('admin-profile-log/content')
    this.columns[4].dataIndex = getLKey() === 'en' ? 'content_en' : 'content_cn'
    this.getList()
  },
  methods: {
    cancel() { // 模态框消失
      this.showModal = false
    },
    getList(page) { // 表格信息初始化
      const params = JSON.parse(JSON.stringify(this.form))
      params.page = typeof page === 'number' ? page : 1

      logs(3, params)
        .then(res => { // 得到的日志的信息，并赋值给表格数据，页码总页数数据
          this.data = res.data
          this.pagination.total = res.total
          this.pagination.current = res.current_page
        })
        .catch(res => {
          console.error(res)
        })
    },
    pageChange(e) { // 当页码改变的时候，表格信息的数据进行重置
      this.getList(e.current)
    },
    showDetail(text) { // 展示模态框
      this.content = text
      this.showModal = true
    },
    timeChange(value, dateString) { // 当时件改变时候，连个被选择的时间进行更新
      this.form.start_date = dateString[0]
      this.form.end_date = dateString[1]
    }
  }
}
</script>
<style scoped>
    .searchBox {
    padding: 34px 20px;
    background: #ffffff;
    }

    .tag {
    width: 4em;
    line-height: 32px;
    }

    .table {
    margin-top: 30px;
    }

    .content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    cursor: pointer;
    }
  </style>

